function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "20",
  viewBox: "0 0 19 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.945 4.536a.749.749 0 01.038-.04l3.45-3.452a.723.723 0 111.024 1.024l-.831.832c.45.126.874.367 1.229.722l5.317 5.317a2.824 2.824 0 010 3.995l-5.317 5.317a2.824 2.824 0 01-3.996 0l-5.317-5.317a2.824 2.824 0 010-3.995l4.403-4.403zM4.524 17.57c0 1.327-1.018 2.413-2.262 2.413S0 18.898 0 17.57c0-1.327 2.262-4.825 2.262-4.825s2.262 3.498 2.262 4.825zm13.028-6.635c0-.352-.134-.704-.404-.974l-5.317-5.317a1.376 1.376 0 00-1.948 0L4.566 9.962c-.27.27-.404.622-.404.974h13.39z",
  fill: "#fff"
})));